{
    "Accessibility menu": "Menu Trợ Năng",
    "Close": "Đóng",
    "Text and Reading": "Văn bản và đọc",
    "Navigation and Interaction": "Điều hướng và tương tác",
    "Text Align": "Căn chỉnh văn bản",
    "Align Left": "Căn Trái",
    "Align Center": "Căn giữa",
    "Align Right": "Căn phải",
    "Adjust Font Size": "Điều Chỉnh Cỡ Chữ",
    "Highlight Title": "Làm Nổi Bật Tiêu Đề",
    "Highlight Links": "Làm Nổi Bật Liên Kết",
    "Readable Font": "Phông Chữ Dễ Đọc",
    "Color and Contrast": "Màu sắc và độ tương phản",
    "Dark Contrast": "Tương Phản Tối",
    "Light Contrast": "Tương Phản Sáng",
    "High Contrast": "Tương Phản Cao",
    "High Saturation": "Bão Hòa Cao",
    "Low Saturation": "Bão Hòa Thấp",
    "Monochrome": "Đơn Sắc",
    "Tools": "Công Cụ",
    "Reading Guide": "Hướng Dẫn Đọc",
    "Big Cursor": "Con Trỏ Lớn",
    "Increase Font Size": "Tăng Cỡ Chữ",
    "Decrease Font Size": "Giảm Cỡ Chữ",
    "Letter Spacing": "Khoảng Cách Chữ",
    "Line Height": "Chiều Cao Dòng",
    "Font Weight": "Độ Đậm Chữ",
    "Dyslexia Font": "Phông Chữ Cho Chứng Khó Đọc",
    "Language": "Ngôn Ngữ",
    "Accessibility widget": "Mở Menu Trợ Năng",
    "Accessibility Profiles": "Hồ Sơ Trợ Năng",
    "Cognitive Disability": "Khuyết Tật Nhận Thức",
    "Seizure Safe": "An Toàn Cho Động Kinh",
    "Accessibility statement": "Tuyên Bố Trợ Năng",
    "ADHD": "ADHD",
    "Low Vision": "Thị lực kém",
    "Pause Animations": "Dừng Hoạt Ảnh",
    "Animation paused": "Đã tạm dừng ảnh động",
    "Reset all settings": "Đặt lại cài đặt",
    "Shortcut:": "Phím tắt:",
    "Epilepsy Safe Mode": "Chế độ an toàn cho người động kinh",
    "Mute sounds": "Tắt âm thanh",
    "Page read": "Đọc trang",
    "Page read controls": "Điều khiển đọc trang",
    "Pause": "Tạm dừng",
    "Resume": "Tiếp tục",
    "Stop": "Dừng",
    "Settings": "Cài đặt",
    "Speed": "Tốc độ",
    "Voice": "Giọng đọc",
    "Close accessibility menu": "Đóng menu trợ năng",
    "Back to accessibility menu": "Quay lại menu trợ năng",
    "Search languages": "Tìm kiếm ngôn ngữ",
    "Selected language": "Ngôn ngữ đã chọn",
    "View accessibility statement (opens in new window)": "Xem tuyên bố về trợ năng (mở trong cửa sổ mới)",
    "Visit CookieYes website (opens in new window)": "Truy cập trang web CookieYes (mở trong cửa sổ mới)",
    "Reset all accessibility settings to default": "Đặt lại tất cả cài đặt trợ năng về mặc định"
}
